import React from 'react';
import { css } from '@emotion/css';
import Container from 'evcharging/components/Container';
import { Theme } from 'evcharging/app/themes';
import useTheme from 'evcharging/hooks/useTheme';
import Paragraph from 'evcharging/components/Paragraph';
import Spacer from 'evcharging/components/Spacer';
import Box from 'evcharging/components/Box';
import Desktop from 'evcharging/components/Desktop';
import useI18n from 'evcharging/hooks/useI18n';

const CalculatorHeader = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  return (
    <header className={styles.root}>
      <Container>
        <Spacer value={98} mobile={68} />
        <h1 className={styles.title}>
          {t('calculator.header1')}
          <Desktop height={'0'}>
            <br />
          </Desktop>{' '}
          {t('calculator.header2')}
        </h1>
        <Spacer value={16} />
        <Box maxWidth={960} margin={'0 auto'}>
          <Paragraph color={'middle'} textAlign={'center'} fontSize={20}>
            {t('calculator.intro1')}
            <Desktop height={'0'}>
              <br />
            </Desktop>{' '}
            {t('calculator.intro2')}
          </Paragraph>
        </Box>
      </Container>
    </header>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    background-color: #f6f8f9;
    ${theme.breakpoints.mobile.down} {
      padding-bottom: 0;
    }
  `,
  title: css`
    padding-top: 28px;
    font-weight: 700;
    font-size: 32px;
    line-height: 130%;
    text-align: center;
    color: #252c32;
    ${theme.breakpoints.mobile.down} {
      font-size: 24px;
    }
  `,
});

export default CalculatorHeader;
